export enum PAGES {
	HOME = 'knowledge-base',
}

export const REMOTE = {
	NAME: 'knowledge_base',
	MANIFEST_PATH: '/remotes/knowledge-base/mf-manifest.json',
} as const;
